module.exports = __webpack_public_path__ + "static/_MG_5001-bd1378e7e9b083128e4ab70343848cfc.jpg";